import React, { useEffect, useState } from 'react';
import { settingsApi } from '../lib/api';
import { Star, Loader2, CheckCircle, XCircle } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Switch } from './ui/switch';
import { toast } from 'sonner';

// "Бот-кошелёк для звёзд": Stars invoices are issued by a separate bot.
// The token is never sent to the browser; an empty field means "keep".
export default function StarsWalletSection() {
  const [view, setView] = useState(null);
  const [enabled, setEnabled] = useState(false);
  const [token, setToken] = useState('');
  const [saving, setSaving] = useState(false);
  const [checking, setChecking] = useState(false);
  const [check, setCheck] = useState(null);

  const load = async () => {
    try {
      const res = await settingsApi.getStarsWallet();
      setView(res.data);
      setEnabled(!!res.data.enabled);
    } catch (e) {
      toast.error('Ошибка загрузки бота-кошелька');
    }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    setSaving(true);
    try {
      const res = await settingsApi.updateStarsWallet({ enabled, token: token.trim() || null });
      setView(res.data);
      setToken('');
      const wh = res.data.webhook;
      if (wh && wh.success === false) toast.error(`Сохранено, но webhook не установлен: ${wh.message}`);
      else toast.success('Бот-кошелёк сохранён');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Ошибка сохранения');
    } finally {
      setSaving(false);
    }
  };

  const runCheck = async () => {
    setChecking(true);
    setCheck(null);
    try {
      const res = await settingsApi.checkStarsWallet(token.trim());
      setCheck(res.data);
    } catch (e) {
      setCheck({ ok: false, error: 'Ошибка проверки' });
    } finally {
      setChecking(false);
    }
  };

  const sourceText = { db: 'из настроек', env: 'из переменных окружения', none: 'не задан' };

  return (
    <div className="card" data-testid="stars-wallet-section">
      <div className="card-header">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-yellow-500/10 flex items-center justify-center">
            <Star className="w-5 h-5 text-yellow-400" />
          </div>
          <div>
            <h3 className="card-title">Бот-кошелёк для звёзд</h3>
            <p className="text-xs text-zinc-500">Счета в Stars выставляет отдельный бот, звёзды зачисляются на него</p>
          </div>
        </div>
      </div>
      <div className="card-content space-y-4">
        <div className="flex items-center justify-between">
          <Label htmlFor="stars_wallet_enabled">Включить бот-кошелёк</Label>
          <Switch id="stars_wallet_enabled" checked={enabled} onCheckedChange={setEnabled} />
        </div>
        <div>
          <Label htmlFor="stars_wallet_token">Токен бота-кошелька</Label>
          <Input
            id="stars_wallet_token"
            type="password"
            autoComplete="off"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            placeholder={view?.token_set ? 'Токен сохранён — введите новый, чтобы заменить' : '123456789:ABCdef...'}
          />
          <p className="text-xs text-zinc-500 mt-1">
            Сейчас: {view ? sourceText[view.source] : '…'}
            {view?.bot_username ? ` (@${view.bot_username})` : ''}. Пустое поле — не менять.
            {view?.previous_wallets ? ' Старые счета прежнего кошелька подтвердятся им же.' : ''}
          </p>
        </div>
        <div className="flex items-center gap-3">
          <Button type="button" variant="outline" onClick={runCheck} disabled={checking}>
            {checking ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Проверить'}
          </Button>
          <Button type="button" onClick={save} disabled={saving}>
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Сохранить кошелёк'}
          </Button>
          {check && (check.ok
            ? <span className="text-sm text-green-400 flex items-center gap-1"><CheckCircle className="w-4 h-4" />@{check.username}</span>
            : <span className="text-sm text-red-400 flex items-center gap-1"><XCircle className="w-4 h-4" />{check.error}</span>)}
        </div>
      </div>
    </div>
  );
}
